import { borgAnalytics, Button, getChannel, useTheme } from '@ytl/common-web';
import { useEffect } from 'react';
import { ReactComponent as IdIcon } from '../../../../assets/id.svg';
import { useLanguage } from '../../../../contexts/languageContext';
import {
  OnboardingPath,
  OnboardingPhase,
  OnboardingStepperControls,
} from '../../../../modules/onboarding/OnboardingComponent';
import { getConfig } from '../../../data/config';

type IdentifyMyselfProps = {
  stepper: OnboardingStepperControls;
};

export const IdentifyMyself = ({ stepper }: IdentifyMyselfProps) => {
  const { translation, language } = useLanguage();
  const { isWebView, isDark } = useTheme();
  const config = getConfig();
  const link = config?.registrationInformationUrl || 'https://www.yettel.hu/fiok-regisztracio';
  const kycInitAppUrl = config?.kycInitAppUrl || '/kyc-init?app=true';

  useEffect(() => {
    borgAnalytics.sendVirtualPageView({
      channel: getChannel(isWebView),
      virtualName: 'Onboarding start',
    });
  }, [isWebView]);

  const handleDAPClick = () => {
    stepper.addPath(OnboardingPath.DAPVerification);
    stepper.goToNext();
  };

  const handleSelfieClick = () => {
    if (isWebView) {
      window.location.href = `${kycInitAppUrl}&locale=${language}&theme=${isDark ? 'dark' : 'light'}`;
    } else {
      stepper.goToPhase(OnboardingPhase.KYCWeb);
    }
  };

  const handleVideochatClick = () => {
    const videoChatUrl = config?.videoChatUrl;
    if (videoChatUrl) {
      window.open(videoChatUrl, '_blank');
    } else {
      console.warn('videoChatUrl nincs konfigurálva');
    }
  };

  const handleAppointmentClick = () => {
    const appointmentUrl = config?.appointmentBookingUrl;
    if (appointmentUrl) {
      window.open(appointmentUrl, '_blank');
    } else {
      console.warn('appointmentBookingUrl nincs konfigurálva');
    }
  };

  return (
    <div className={`onboarding-step${isWebView ? ' onboarding-step--webview' : ''}`}>
      <h3 className="onboarding-step__header">{translation.onboarding?.identifyMyself?.header}</h3>

      <p className="onboarding-step__description">{translation.onboarding?.identifyMyself?.description}</p>

      <ul className={`onboarding-step__benefits${isWebView ? ' onboarding-step__benefits--webview' : ''}`}>
        <li>{translation.onboarding?.identifyMyself?.benefit1}</li>
        <li>{translation.onboarding?.identifyMyself?.benefit2}</li>
        <li>{translation.onboarding?.identifyMyself?.benefit3}</li>
      </ul>
      <p
        className="onboarding-step__instruction"
        dangerouslySetInnerHTML={{ __html: translation.onboarding?.identifyMyself?.instruction(link) }}
      />

      <div className={`onboarding-step__actions${isWebView ? ' onboarding-step__actions--webview' : ''}`}>
        {getConfig().kycEnabled && (
          <Button
            variant="contained"
            onClick={handleSelfieClick}
            className="onboarding-step__dap-button"
          >
            {translation.onboarding?.identifyMyself?.selfieButton}
          </Button>
        )}
        <Button
          variant={getConfig().kycEnabled ? 'outlined' : 'contained'}
          onClick={handleDAPClick}
          className="onboarding-step__dap-button"
        >
          {translation.onboarding?.identifyMyself?.dapButton}
          <IdIcon className="onboarding-step__dap-icon" />
        </Button>

        <Button
          variant="outlined"
          onClick={handleVideochatClick}
        >
          {translation.onboarding?.identifyMyself?.videoChatButton}
        </Button>

        <Button
          variant="outlined"
          onClick={handleAppointmentClick}
        >
          {isWebView
            ? translation.onboarding?.identifyMyself?.appointmentButtonApp
            : translation.onboarding?.identifyMyself?.appointmentButton}
        </Button>
      </div>
    </div>
  );
};
